import React, {useEffect, useRef, useState}  from 'react'
import "./css/Home.css"
import {Link, useNavigate} from "react-router-dom" ;
import Rally from "./Rally"
import CurrentStreak from "./CurrentStreak"
import { AnimatePresence, motion } from 'framer-motion';
//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setLoginStatus, setPhoto, setUserName,setReduxUserID } from "./redux/isLoggedIn"
//FirebaseError
import { db } from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc, setDoc } from 'firebase/firestore';


const Home = React.memo(props => {
     let dispatch = useDispatch();
     let navigate = useNavigate();
     const appWidthRef = useRef(null);


     useEffect(() => {
          //redux stuff
          // dispatch(setLoginStatus(true));
          // dispatch(setReduxUserID(cred.user.uid));
          // dispatch(setUserName(userName));
          // dispatch(setPhoto("http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg"));
     }, []);



     return (
          <motion.div initial={{x:-768, opacity:0}} animate={{x:0, opacity:1}} exit={{x:768, opacity:0}} transition={{duration:0.2}}>
               <div className='homeContainer' ref={appWidthRef}>

                    <div className="homeOptionWrapper" onClick = { () => navigate("/app/addMenu") }  >
                         <div className="">
                              <p className="">Add an Item</p>
                         </div>
                    </div>

                    <div className="homeOptionWrapper"  onClick = { () => navigate("/app/quizMenu") }  >
                         <div className="">
                              <p className="">Quiz Yourself</p>
                         </div>
                    </div>

                    <div className='homeSmallerSections'>
                         <Rally />
                         <CurrentStreak />
                    </div>


               </div>
          </motion.div>
     )
})

export default Home
